webpackJsonp([1],{

/***/ "+7iM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0POj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0Qla":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2Env":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cbf575f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminSettingsGeneral_vue__ = __webpack_require__("gR74");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cbf575f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminSettingsGeneral_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3ppe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var uploadCodes = {
  STATUS_INITIAL: 0,
  STATUS_UPLOADING: 1,
  STATUS_SUCCESS: 2,
  STATUS_FAILURE: 3,
  STATUS_PAUSED: 4,
  STATUS_PROCESSING: 5
};

var MD5 = __webpack_require__("gykg");

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['collective'],
  data: function data() {
    return {
      rawImages: [], // Raw images with information for the status
      images: [], // Promises of uploads
      imageStatus: [],
      imageProgress: [],
      imageTasks: [],
      currentStatus: uploadCodes.STATUS_INITIAL,
      errors: [],
      imageIndex: 0
    };
  },
  methods: {
    // TODO: Move to main Vuex store
    uploadFiles: function uploadFiles(e) {
      var _this = this;

      this.currentStatus = uploadCodes.STATUS_UPLOADING;
      var imageFiles = e.target.files;

      var firebaseStore = this.$firebase.storage();

      var _loop = function _loop(index) {
        var imageIndex = _this.imageIndex;
        var image = imageFiles[index - imageIndex];

        _this.imageStatus.push(uploadCodes.STATUS_INITIAL);
        _this.rawImages.push(image);
        _this.imageProgress.push(0);

        _this.images.push(new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          var imageName = image.name.split(' ').join('_').split('.').slice(0, -1).join('.') + '.' + MD5(image.name + image.lastModified) + '.' + MD5(image.lastModified + ':' + new Date().getTime()) + '.' + image.name.split('.')[image.name.split('.').length - 1];
          var imageRef = firebaseStore.ref().child('collectives/@' + _this.collective.handle + '/' + imageName);

          _this.imageStatus[index] = uploadCodes.STATUS_UPLOADING;
          var task = imageRef.put(image);
          _this.imageTasks.push(task);

          task.on('state_changed', function (snapshot) {
            // Update the upload speed
            _this.$set(_this.imageProgress, index, snapshot.bytesTransferred / snapshot.totalBytes * 100);
          }, function (err) {
            // Reject when there is an error
            _this.$set(_this.imageStatus, index, uploadCodes.STATUS_FAILURE);
            reject(err);
          }, function (snapshot) {
            // Successful!
            _this.$set(_this.imageStatus, index, uploadCodes.STATUS_PROCESSING);

            return _this.setImageMetadata(imageFiles[index - imageIndex], imageName).then(function () {
              _this.$set(_this.imageStatus, index, uploadCodes.STATUS_SUCCESS);
              resolve(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, image, { finishedUploading: true }));
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, image, { finishedUploading: true });
            });
          });
        }).catch(function (err) {
          _this.errors.push(err);
        }));
      };

      for (var index = this.imageIndex; index < imageFiles.length + this.imageIndex; index++) {
        _loop(index);
      }

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(this.images.slice(this.imageIndex, this.images.length)).then(function (results) {
        _this.$store.dispatch('fetchCollective', _this.collective.handle);
        if (results.filter(function (value) {
          return !value.finishedUploading;
        }).length === 0) {
          _this.currentStatus = uploadCodes.STATUS_SUCCESS;
        } else {
          _this.currentStatus = uploadCodes.STATUS_FAILURE;
        }
      });

      this.imageIndex += imageFiles.length;
    },
    reset: function reset() {
      this.currentStatus = uploadCodes.STATUS_INITIAL;
      this.images = [];
    },
    setImageMetadata: function setImageMetadata(image, imageName) {
      var tag = '$all';
      var imageUpdate = {
        timestamp: new Date().getTime()
      };
      var imageStuff = {
        name: image.name.split('.').slice(0, -1).join('.'),
        path: imageName,
        fullpath: 'collectives/@' + this.collective.handle + '/' + imageName,
        timestamp: new Date().getTime()
      };
      imageUpdate['images.' + tag + '@' + MD5(imageName).toString()] = true;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([this.$firestore.collection('images').doc('@' + this.collective.handle).collection(tag).doc(MD5(imageName).toString()).set(imageStuff), this.$firestore.collection('collectives').doc('@' + this.collective.handle).update(imageUpdate)]);
    },
    togglePauseTask: function togglePauseTask(index) {
      if (this.imageStatus[index] === uploadCodes.STATUS_UPLOADING) {
        this.$set(this.imageStatus, index, uploadCodes.STATUS_PAUSED);
        this.imageTasks[index].pause();
      } else if (this.imageStatus[index] === uploadCodes.STATUS_PAUSED) {
        this.$set(this.imageStatus, index, uploadCodes.STATUS_UPLOADING);
        this.imageTasks[index].resume();
      } else {
        throw new Error('Attempted to pause an upload in an invalid fashion!');
      }
    }
  },
  mounted: function mounted() {
    // this.reset()
  }
});

/***/ }),

/***/ "4k82":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminUpload_vue__ = __webpack_require__("3ppe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25f062ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminUpload_vue__ = __webpack_require__("6TOS");
function injectStyle (ssrContext) {
  __webpack_require__("Fmto")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminUpload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25f062ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminUpload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5AUI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/MockGalleryFeatures.70ccc14.png";

/***/ }),

/***/ "5X6r":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/MockMembers.a4786e0.png";

/***/ }),

/***/ "5hWu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      mode: 'collectives',
      loading: true
    };
  },
  methods: {
    changeMode: function changeMode(mode) {
      if (this.mode !== mode) {
        this.mode = mode;
        this.loading = false;
      }
    },
    goToCollective: function goToCollective(handle) {
      this.$router.push('/admin/' + handle + '/d');
    },
    goToOnboarding: function goToOnboarding() {
      this.$router.push('/onboarding');
    }
  },
  computed: {
    title: function title() {
      if (this.mode === 'services') {
        return 'Services';
      } else {
        return 'Your Collectives';
      }
    },
    userCollectives: function userCollectives() {
      return this.$store.state.userCollectives;
    }
  },
  created: function created() {
    var _this = this;

    this.$firebase.auth().onAuthStateChanged(function (user) {
      _this.$store.dispatch('fetchUserCollectives').then(function () {
        _this.loading = false;
      });
    });
  }
});

/***/ }),

/***/ "69AX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"v-dashboard-frame"}},[_c('header',{staticClass:"ob-header"},[_c('div',{staticClass:"ob-header-heading"},[_c('h5',[_vm._v("Dashboard")]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"ob-header-profile"},[_c('div',{staticClass:"ob-header-profile-head"},[_c('b',{staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(_vm.$store.getters.user.fullname))]),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"0.8em","color":"#929292"}},[_vm._v("@"+_vm._s(_vm.$store.getters.user.handle))])]),_vm._v(" "),_c('img',{staticClass:"ob-header-profile-img",attrs:{"src":_vm.$store.getters.user.userProfileImg}})])]),_vm._v(" "),_c('div',{attrs:{"id":"d-dashboard-menu"}},[_c('div',{staticClass:"d-dashboard-menu-left d-dashboard-menu-nav",on:{"click":function($event){_vm.changeMode('collectives')}}},[_c('div',{class:{active: _vm.mode === 'collectives'}},[_vm._v("Your Collectives")])]),_vm._v(" "),_c('div',{staticClass:"d-dashboard-menu-right d-dashboard-menu-nav",on:{"click":function($event){_vm.changeMode('services')}}},[_c('div',{class:{active: _vm.mode === 'services'}},[_vm._v("Services")])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[(_vm.loading)?_c('div',{staticClass:"c-loading",staticStyle:{"margin-top":"40px","margin-bottom":"40px"}}):_vm._e(),_vm._v(" "),(_vm.mode === 'collectives' && !_vm.loading)?_c('div',{key:"collectives",staticClass:"d-dashboard-menu-view"},[(Object.keys(_vm.userCollectives).length)?_c('div',{staticStyle:{"margin-top":"20px"}},[_vm._l((_vm.userCollectives),function(collective){return _c('div',{key:collective.handle,staticClass:"dashboard-collective",on:{"click":function($event){_vm.goToCollective(collective.handle)}}},[_c('b',[_vm._v(_vm._s(collective.fullname))]),_vm._v(" "),_c('span',[_vm._v("(@"+_vm._s(collective.handle)+")")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12px"}},[_vm._v("\n            "+_vm._s((collective.images ? Object.keys(collective.images).length : 0))+" images | "+_vm._s(Object.keys(collective.members).length)+" members\n          ")])])}),_vm._v(" "),_c('button',{staticStyle:{"margin":"20px 0"},attrs:{"to":"/onboarding"},on:{"click":function($event){_vm.goToOnboarding()}}},[_vm._v("Create/Join Collective")])],2):_c('div',[_c('h1',{staticClass:"h-thin",staticStyle:{"font-size":"2em"}},[_vm._v("Welcome to Prism")]),_vm._v(" "),_c('p',{staticStyle:{"max-width":"500px","margin":"0 auto","line-height":"1.5"}},[_vm._v("It doesn't seem like you are a part of a collective yet. Would you like to "),_c('router-link',{attrs:{"to":"/onboarding"}},[_vm._v("create or join one?")])],1)])]):_vm._e(),_vm._v(" "),(_vm.mode === 'services' && !_vm.loading)?_c('div',{key:"services",staticClass:"d-dashboard-menu-view"},[_c('h1',{staticClass:"h-thin",staticStyle:{"font-size":"2em"}},[_vm._v("Here are your past & coming services")])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6TOS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"v-admin-panel-upload"}},[_c('div',{staticClass:"v-admin-uploading"},[_c('form',{attrs:{"enctype":"multipart/form-data"}},[_c('input',{attrs:{"type":"file","accept":"image/*","multiple":"","disabled":_vm.currentStatus !== 0 && _vm.currentStatus !== 2},on:{"change":function($event){_vm.uploadFiles($event)}}}),_vm._v(" "),_c('span',[_vm._v("Upload pictures to your Prism library.")])])]),_vm._v(" "),(_vm.currentStatus === 0)?_c('div',{staticClass:"v-tip-friendly",staticStyle:{"margin-top":"40px"}},[_c('img',{staticClass:"tip-icon",attrs:{"src":__webpack_require__("uk3/")}}),_vm._v(" "),_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.errors.length)?_c('div',{staticClass:"v-admin-image-errors"},[_c('ul',_vm._l((_vm.errors),function(error){return _c('li',{key:error},[_c('b',[_vm._v(_vm._s(error.name))]),_vm._v(": "+_vm._s(error.message))])}))]):_vm._e(),_vm._v(" "),_vm._l((_vm.rawImages),function(image,index){return _c('div',{key:index,staticClass:"v-admin-image-part"},[_c('b',[_vm._v(_vm._s(image.name))]),_vm._v(" "),_c('span',{staticStyle:{"color":"#aaa"}},[_vm._v("#"+_vm._s(index + 1))]),_vm._v(" "),(_vm.imageStatus[index] === 0)?_c('div',{staticClass:"v-admin-image-status"},[_vm._v("PREPARING")]):_vm._e(),_vm._v(" "),(_vm.imageStatus[index] === 1)?_c('div',{staticClass:"v-admin-image-status uploading"},[_vm._v("UPLOADING")]):_vm._e(),_vm._v(" "),(_vm.imageStatus[index] === 2)?_c('div',{staticClass:"v-admin-image-status success"},[_vm._v("SUCCESS")]):_vm._e(),_vm._v(" "),(_vm.imageStatus[index] === 3)?_c('div',{staticClass:"v-admin-image-status error"},[_vm._v("UPLOAD FAILED")]):_vm._e(),_vm._v(" "),(_vm.imageStatus[index] === 4)?_c('div',{staticClass:"v-admin-image-status"},[_vm._v("PAUSED")]):_vm._e(),_vm._v(" "),(_vm.imageStatus[index] === 5)?_c('div',{staticClass:"v-admin-image-status"},[_vm._v("PROCESSING")]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(Math.round(_vm.imageProgress[index]))+"%")]),_vm._v(" "),(_vm.imageStatus[index] === 1)?_c('i',{staticClass:"material-icons icon-button",on:{"click":function($event){_vm.togglePauseTask(index)}}},[_vm._v("pause")]):_vm._e(),_vm._v(" "),(_vm.imageStatus[index] === 4)?_c('i',{staticClass:"material-icons icon-button",on:{"click":function($event){_vm.togglePauseTask(index)}}},[_vm._v("play_arrow")]):_vm._e()])})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tip-content"},[_c('b',[_vm._v("Uploading multiple images?")]),_vm._v(" "),_c('span',[_vm._v("\n        No problem! You can select multiple images to upload at once.\n      ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7Otq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.7f8ebaa.png";

/***/ }),

/***/ "7cGy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminFrame_vue__ = __webpack_require__("U3gX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ffd891ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminFrame_vue__ = __webpack_require__("tN4C");
function injectStyle (ssrContext) {
  __webpack_require__("vlpO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminFrame_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ffd891ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminFrame_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9HFc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9dYn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: true
    };
  },
  created: function created() {
    var _this = this;

    setTimeout(function () {
      _this.$firebase.auth().signOut();
      _this.loading = false;
    }, 1000);
  }
});

/***/ }),

/***/ "9zlg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"v-collective-members"}},[_c('img',{attrs:{"src":__webpack_require__("5X6r")}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Bqv4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"v-admin-panel-followers"}},[_c('ul',[_vm._v(_vm._s(_vm.collective.followers))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ce38":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D94e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['collective']
});

/***/ }),

/***/ "F8aH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75aaa60d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LaunchPage_vue__ = __webpack_require__("vaHH");
function injectStyle (ssrContext) {
  __webpack_require__("UVKX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75aaa60d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LaunchPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Fmto":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GSIy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gallery_vue__ = __webpack_require__("NpDO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b5ccfe4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gallery_vue__ = __webpack_require__("dd06");
function injectStyle (ssrContext) {
  __webpack_require__("VGFo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gallery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b5ccfe4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gallery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HitT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cd5ff4f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageForbidden_vue__ = __webpack_require__("qTfU");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cd5ff4f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageForbidden_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IqjC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminSettingsMembers_vue__ = __webpack_require__("D94e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8da4f690_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminSettingsMembers_vue__ = __webpack_require__("PNCf");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminSettingsMembers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8da4f690_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminSettingsMembers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JU1R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_LaunchPage__ = __webpack_require__("F8aH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PageNotFound__ = __webpack_require__("lM8h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_PageForbidden__ = __webpack_require__("HitT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_LoginPage__ = __webpack_require__("YlY5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_LogoutPage__ = __webpack_require__("TRT9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Collective_CollectiveFrame__ = __webpack_require__("tHcj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Collective_CollectiveGallery__ = __webpack_require__("rTZy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Collective_CollectiveMembers__ = __webpack_require__("MFcx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Collective_CollectiveServices__ = __webpack_require__("XGmb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Admin_AdminFrame__ = __webpack_require__("7cGy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Admin_EmptyFrame__ = __webpack_require__("RY5o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Onboarding_OnboardingFrame__ = __webpack_require__("KkWr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Dashboard_DashboardFrame__ = __webpack_require__("ezJm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Admin_General_AdminDashboard__ = __webpack_require__("YlMb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Admin_General_AdminFollowers__ = __webpack_require__("xLCW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Admin_General_AdminSupport__ = __webpack_require__("QA28");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Admin_General_AdminImageDrive__ = __webpack_require__("TUra");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Admin_General_AdminServices__ = __webpack_require__("M++E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Admin_General_AdminUpload__ = __webpack_require__("4k82");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Admin_Settings_AdminSettingsGeneral__ = __webpack_require__("2Env");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Admin_Settings_AdminSettingsMembers__ = __webpack_require__("IqjC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Admin_Settings_AdminSettingsPolicies__ = __webpack_require__("Mo0v");





// COMPONENTS














// Admin Panel










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{ // Login path - /login
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_7__components_LoginPage__["a" /* default */]
  }, {
    path: '/logout',
    name: 'Logout',
    component: __WEBPACK_IMPORTED_MODULE_8__components_LogoutPage__["a" /* default */]
  }, {
    path: '/onboarding',
    name: 'Onboarding',
    component: __WEBPACK_IMPORTED_MODULE_15__components_Onboarding_OnboardingFrame__["a" /* default */]
  }, {
    path: '/dashboard',
    name: 'Dashboard',
    component: __WEBPACK_IMPORTED_MODULE_16__components_Dashboard_DashboardFrame__["a" /* default */],
    beforeEnter: function beforeEnter(to, from, next) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$firebase.auth().onAuthStateChanged(function (u) {
        if (u) {
          next();
        } else {
          next('/forbidden');
        }
      });
    }
  }, { // Admin Routes - /admin
    path: '/admin/:slug/',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_14__components_Admin_EmptyFrame__["a" /* default */],
    beforeEnter: function beforeEnter(to, from, next) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$firebase.auth().onAuthStateChanged(function (u) {
        if (u) {
          __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('fetchCollective', to.params.slug).then(function (result) {
            if (result) next();else next('/404');
          });
        } else {
          next('/forbidden');
        }
      });
    },
    children: [{
      path: 'd',
      component: __WEBPACK_IMPORTED_MODULE_13__components_Admin_AdminFrame__["a" /* default */],
      props: true,
      children: [{ path: 'upload', name: 'AdminUpload', component: __WEBPACK_IMPORTED_MODULE_22__components_Admin_General_AdminUpload__["a" /* default */] }, { path: 'dashboard', name: 'AdminDashboard', component: __WEBPACK_IMPORTED_MODULE_17__components_Admin_General_AdminDashboard__["a" /* default */] }, { path: 'images', name: 'AdminImageDrive', component: __WEBPACK_IMPORTED_MODULE_20__components_Admin_General_AdminImageDrive__["a" /* default */] }, { path: 'services', name: 'AdminServices', component: __WEBPACK_IMPORTED_MODULE_21__components_Admin_General_AdminServices__["a" /* default */] }, { path: 'followers', name: 'AdminFollowers', component: __WEBPACK_IMPORTED_MODULE_18__components_Admin_General_AdminFollowers__["a" /* default */] }, { path: 'widgets', name: 'AdminSupport', component: __WEBPACK_IMPORTED_MODULE_19__components_Admin_General_AdminSupport__["a" /* default */] }, { path: 'general', name: 'AdminSettingsGeneral', component: __WEBPACK_IMPORTED_MODULE_23__components_Admin_Settings_AdminSettingsGeneral__["a" /* default */] }, { path: 'members', name: 'AdminSettingsMembers', component: __WEBPACK_IMPORTED_MODULE_24__components_Admin_Settings_AdminSettingsMembers__["a" /* default */] }, { path: 'policies', name: 'AdminSettingsPolicies', component: __WEBPACK_IMPORTED_MODULE_25__components_Admin_Settings_AdminSettingsPolicies__["a" /* default */] }, { path: '', redirect: 'dashboard' }]
    }, { path: '', redirect: 'd' }]
  }, { // Collective Routes - /@
    path: '/@/:slug/',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Collective_CollectiveFrame__["a" /* default */],
    props: true,
    children: [{
      path: 'gallery',
      component: __WEBPACK_IMPORTED_MODULE_10__components_Collective_CollectiveGallery__["a" /* default */],
      children: [{ path: 'page/:pageNum', component: __WEBPACK_IMPORTED_MODULE_10__components_Collective_CollectiveGallery__["a" /* default */], props: true }]
    }, { path: 'members', component: __WEBPACK_IMPORTED_MODULE_11__components_Collective_CollectiveMembers__["a" /* default */] }, { path: 'services', component: __WEBPACK_IMPORTED_MODULE_12__components_Collective_CollectiveServices__["a" /* default */] }, { path: '', redirect: 'gallery' }]
  }, { // Home Page - /
    path: '/',
    name: 'Launch',
    component: __WEBPACK_IMPORTED_MODULE_4__components_LaunchPage__["a" /* default */]
  }, {
    path: '/forbidden',
    name: 'Forbidden',
    component: __WEBPACK_IMPORTED_MODULE_6__components_PageForbidden__["a" /* default */]
  }, { // 404 Route - **
    path: '*',
    component: __WEBPACK_IMPORTED_MODULE_5__components_PageNotFound__["a" /* default */]
  }]
}));

/***/ }),

/***/ "KBza":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Components_Gallery__ = __webpack_require__("GSIy");
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['collective'],
  components: { Gallery: __WEBPACK_IMPORTED_MODULE_0__Components_Gallery__["a" /* default */] }
});

/***/ }),

/***/ "KkWr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnboardingFrame_vue__ = __webpack_require__("OSbk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_626b7929_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OnboardingFrame_vue__ = __webpack_require__("ynP9");
function injectStyle (ssrContext) {
  __webpack_require__("v5p1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnboardingFrame_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_626b7929_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OnboardingFrame_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LYWo":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAjgAAABkCAYAAACLpkpTAAAABGdBTUEAALGPC/xhBQAAH/tJREFUeAHtnQmUVMW9xmsGGLaRTZZhERSXRAYGEBAQiIKKoHGLESU+Mei8x+IOifHluTx88UkSY6IwoBHkiGvEBRcWUYYoImsURhEFBQRhkH3fGfJ9Zdec62WWntvdM909X51zubfq1vqry/y//lfd7hTjC3v27Mk8evRo9vHjx/viVksc6b4siopAWQjsReZ1KSkps6pWrTrhpJNOWl6WwqXlxXOaiTzZOPS8lgYr2H07fyg6C8cEzGNU5y9Yl1RKBERABEonkOKywFCk7dy58zHEh+E61aXrLALRIgDjWIC6xterV28Erg9HUi+fV5S3zyvOel4jgRl+WTt/yB7x/IXfpHKKgAiIQDACVuCExM0MnPsEq0alRCB8AhA3uRA5/YOKnJC4mYEW9byGjz2aOXNRWeD5i2ZHVJcIiIAIFEfAfvKl50bipjhESo82AT5rIW9h0KrpuZG4CUov8nJkzzlQEAEREIG4JZAS2nOTB6NjxU7c9lQdSyoCXK7Cnpyssu7JwXPKPTd5OPS8VuwTweWqLMyj9uRU7DyodREQgWIIpIY2FMtYFANIybEhQEHNZy9A7Syj5zUAuCgX4RwEmb8od0PViYAIiEDRBFJhaPj2iYIIlDuBgM+entdyn6liG9RcFItGN0RABCqaAD+FtazoTqj9SksgyLMXpEylBRzjgWsuYgxY1YuACAQnQIGj77kJzk8lIyMQ5NkLUiayXqp0cQQ0F8WRUboIiECFE9BehgqfAnVABERABERABEQg2gQkcKJNVPWJgAiIgAiIgAhUOAEJnAqfAnVABERABERABEQg2gSSUuB8/PHHZtKkSeb777+3vFauXGnGjh1r5s6dG21+Jdbn70eJmQPc/O6778zEiRPN4sWLA5RWkUgJrFu3zj5X8+bNi7SqQOX/+c9/mpycHLNx48awy7/11ltm9OjRhn1XEAEREIFkJlA1loN75plnTH5+fpFN3HrrrQZf11/kvUgTV69ebf/ob9682TRp0sQcOXLE7Nq1yxw4cKDYqufPn29yc3NNnz59TPfu3YvNV5Yb/n4cPnzYfPTRR2bv3r3miiuuKEtVJi8vzyxfvtxceumlpm7durYsBdymTZsMvizPdOnSpUz1VcbMFLkUhffcc49p0KBBxAgoLFhfnTp1TI8ePWx9TKPgOfXUUyOek9L6u2rVKrN+/Xor5Js1axbWePbt22fwLdL2/0RYBZRJBERABBKUQEwFjmPSuXNnU7NmTRe15xo1avwoHs3IwIEDDb6hOWYCKty++vtx8OBBQyFF0VXW8Mknn5gNGzaYgoKCwqKdOnUyrVu3LhQ8hTd0US4EunXrZs4666wfPWcUtf/6179Mo0aNYt6Hm2++2Qr3aIi1mHdWDYiACIhAORMoF4HTtWvXHxkB7xjHjRtnmjdvbj/x0vjTy9GuXTvTq1cvM2PGDPP111+bxo0bW68KjTkDP4XOmTPHfPvttwZfFmeNfIcOHYz7FDt79mzDT7dXXnmladGihbe5Ml27vp122mlWmNAT1KZNG3P++edbb9DkyZOtcBs8eHBhvc8995z10Nx0003WW+P6QcHFfjFs3brVLi3wOjs721SvXt3W/9VXX5lt27aZU045xfzkJz8x7du3tzyefvppK9iY/4UXXjD4enxzwQUX2LbJqG3btrZPvE8vFT1RNLSHDh0yDRs2tCxPP/103rbpLNOzZ0/rfWD/6tevbyhCMzP5KwjG7N+/38yaNcveZx3kTw+F428zJcE/b7/9tvnyyy/NddddZ2bOnGm9YWeeeaa58MIL7ZjJmh4ZClX3HH344Ydm4cKF5qKLLjLp6elm6tSphs/exRdfbF599VWzYsUKS4b5uHTYqlUrM2DAAPvMTp8+3T7PZMpn9bLLLrPPflCUrM/1v2XLlvaZZ3/oheT/jS+++MKcfPLJdu6ysrKKbIbPIseJn80wN954o/VGFZlRiSIgAiKQYATKZQ/O2rVr7R92ihUeXi8E3eU0stwfQyFBwcK9K0899ZR1pZ9xxhn2jzX/mLswbdo089lnn5mzzz7biqFly5aZl156yeCr/20W54Z3cVeurGfXNxorGir2jSKMe3po3Lg0QQPoluG2bNli9zZw6a1WrVrWqLEO9oNpHAsDvVcUSjyqVKlix0JRQi8XhQeNzjvvvGO58D7zsT4GChXGWR/FIOv3Lr3RyC5dutQa6HPOOcds377dvPzyy1assLwr895771kxxT6x/+TLewyvvfaaXQ776U9/avvD9DfffNPQA5VMgUuFFJQUpeSZkZFh+Cy9//77dphkzft81lygd4bLnfTcUKjwPp83Bi5LNW3a1F6zLgp1PtMMFMMsSwF13nnn2WUl7p+imAwaXP8pvBlcf/jscHmW80evH+fT5fG2xWeD4pnjufrqqyVuvHB0LQIikPAEysWDQ0HiDSNHjrRG3qXxD/MNN9xgjQM/cb777rvWS8FPlAw7duywew34x5renksuucT+AaexoOjgp1XuRaAwoGGJZmDffvWrX9lP3PwUT0NPTwvFFT+5s23Gadh4ZqDnxR94v3bt2tbIURz17t27MAsNEYMTPPTQUIBwfwfHyLxsh14gLovQ48LAT+/eQKPGzaNkSK8EA69p8JYsWVLohWA6RdagQYN4aY0sRSa9PuyLM7rsLz1JHCeNeCyXFW1HKuifjh072r1NFHKjRo2yng+KcI6bzy49If3797fPF/c9UbiQjT/QC0YRSBFPAUQvGwNFMOePgoleRQaypKjkvqpo75+iUB46dKhth3PJ/lOUOw8db/D/1JQpU+xcDxkypND7aQvpHxEQARFIAgLlInDo4ncbY8mMSzLewLj75EuvCANd7i64NPcplMaFwuPFF1+0n1Cd5+HYsWOuSNTO7Jtb+nLCgm0zUAxQjNF40JhRcNC4UBSUJVSrVs16ELh0RJFBIcNQ1vHQm8NAEeiC48pP6d5Ab4MLbg+H40tBxbdt6FXiwftclnP5XLlkOVNEMqSlpdkN2+RIgUMRQjHD/U/0zlGMMJRVkLh5+eabb8z9999v63D/UGhEO7jlSNZLgcvg/o/YCP6hUHfzTU+QggiIgAgkG4FyETg0jFwCKC7QY+EPqanFr57R+HKvA5dzKCw++OADKwz8dUQjXlTfXL3ct8BPxVx6WLNmjV12oPHjslJJgV4nb+BYXn/9dbvHhW9JcemAHpyigr+sNw/fpmJwr8fzmoaZwYlEG8E/7HtxgeJy+PDhVjzSKHPJi94G7sFJRi9OSc8avTIUOBQ3PPgcO0FUHD+me+fJiXsKT3qCGChe2a4TIDYxSv+U9vyxGX5IuOaaa8yzzz5rn70RI0Yk5dxGCamqEQERSEACxVu5KA6Ge2r8hpGfjIO8acJP1jS6/CPO/Q005muxx4eB19wQ6w/OwHCZgPspKEpKMmr+8iXFuYxBgUPvCwOXO4oLXJqih4dLaSxDTw0FGj1ADNxczMB9IAz8dM9P1yxHVlyiI0tuHPZ+SreZ8Q/fzuL4yYGChNfcEMtA3uEE7hfinhTu+eHYKHbYP/aVniv/PIZTZyLnoaijCOGGYe634QbkkkSve0OOc8h5o5DkkiU9aVyq4lIgPYKLFi2y88vlodICv++Gz403OKHkTSvL9VVXXWWFGjckc0M5N1xfe+21ZalCeUVABEQgrgmUi8D59NNPT4DAP/hBBA6FCb+nZsGCBdYQ0/hcfvnlVmBQZBRl+PnJmYaa+1PoGQnX2J/Q6SISuOeHRo2igoarpDGx7/Q68XtS+NYOvQHccMrNwNxDRE8Ul8QoeijEKCwoerjvhq+E00DScHJJiyLHH1g/jRT3jdDrQi8CDSONodvg7C/jj9Mgs098S41v5LBOjotLVE4o+sske5xeHLcvjNclBXLm/iwKGW7u5bNK0cv9ZG+88YbdTE+R7pb9wmFKMeQP/fr18yeVKc5niIHPGp8pCm6+jce+K4iACIhAMhBIwXLIj9dLEmRUdPHT2+D289BocE+Bixc1DL5txH0W4bjwiyofrTQKD27+9G9UZZp7W4pt+eNM4xg4RgqPkgLZ0OPib6OkMv57bt8GmcUqwNCfuD5ZQmNglxDPK59FdtXPjs8t58U7zyUMN+5vwZtVpvmL+wGpgyIgAklDIGEFTtLMQCUfSLIKnMoyrRI4lWWmNU4RSDwCJbsBEm886rEIiIAIiIAIiIAIGAkcPQQiIAIiIAIiIAJJR0ACJ+mmVAMSAREQAREQARGQwNEzIAIiIAIiIAIikHQEKHD0NaZJN60JM6Agz16QMgkDJME6qrlIsAlTd0WgMhGgwFlXmQasscYVgSDPXpAycTXoJOqM5iKJJlNDEYFkI5CK1zxnJdugNJ7EIBDw2dPzGj/Tq7mIn7lQT0RABHwEUvHNtRNgaAp86YqKQEwJ8JnjsxegEZbR8xoAXJSLcA6CzF+Uu6HqREAERKBoAqn4gUb+RPL4om8rVQRiRmB86NkrUwMQRnpey0QsZpnHh+YiZg2oYhEQARGIhID9mnV8pXzazp07Z+DcJ5LKVFYEwiEAw5iL3+Hqj/PhcPL78/B5RRp/3VTPqx9O+cRz0Uzg+SufLqoVERCByk4glQBoaEIGJwfXcv9X9qciRuPns4UjJxJx455XnPvjyMGh55VQyieQNZlL3JQPb7UiAiIQAYETfihvz549mfihxmx8Su6LelviSI+gfhUVAb5KvA7CZhb33ARZlioJIZ7TTNzPxqHntSRQwe/Z+UNxbijmfj0uESqIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAiIgAhUWgIplXbkGrgIiIAIiIAIiECpBPLz8zOPHz+enZKS0heZW+I6vdRC5ZAB/dmLZtahP7NwPaFp06bLvc1K4Hhp6FoEREAEREAERMASgHBI27Rp02OIDMN1ajxjgcApQP/GZ2RkjMD1YfZVAieeZ0x9EwEREAEREIEKIBASNzNw7lMBzQduEuImFyKnP0VOXCuywCNUQREQAREQAREQgcAE6LlJNHHDwbLPIa+TPDiBZ18FRUAEREAERCAJCXDPDYaVB7GQkE6Q0HJVVtUknBsNSQREQAREQAREICABCJtsFE1IccMhh4RZdsIOIOC8qZgIiIAIiIAIiEAJBOAB4dtSCR04BgmchJ5CdV4EREAEREAEok6gZdRrLP8KW0rglD90tSgCIiACIiACcUsASzxx8T03kQDiGCRwIiGosiIgAiIgAiIgAnFJQAInLqdFnRIBERABERABEYiEgAROJPRUVgREQAREQAREIC4JSODE5bSoUyIgAiIgAiIgApEQkMCJhJ7KioAIiIAIiIAIxCWBiL/ob9GiRV0KCgq6RDK61NTUxeeee+7iSOpQWREQAREQAREQARFwBCL6sc0FCxaMwqtYD7jKIjnjS3ke6tat24OR1KGy5UvgiSeeaIP5/wN+ov76AQMG2F9vLd8eqDUREAEREIFoE9i4cePxSOpEedOsWbNIqohK2Yg8ODBuQyFMcDq+Dr1pFbBH36KOlqwL5RNK4MDAd0O/O6HfzXHswzjWV6tWbeawYcM2B2SRUMXgeWt49OjRq9HpKgnVcXVWBERABEQgZgRgG02rVq1Mjx49TNu2bQ1sRczaKqniSFttAAN/rFatWpkw7n9BQ8dKasx37xjLsCzrwL0GvvtxGx0zZky7xx9/fAX6/SQ6yW98zMfRCEt1dx8+fHgd7pGFggiIgAiIgAhUSgJr1qwxzz//vHnkkUdMbm6u2bdvX7lziMiDw95CpKQeOHCgPpaXfoP9OM8fO3bs70gubU/O4ipVqvwX9t0sxTJXC9YBsVBQ7qMP0CDEy5kQMtNRdOSdd975ir+Kp556quHBgwenI9+DuD/Kf19xERABERABEagsBHbt2mVmzpxpZs+ebTp06GDOO+8807w5Fz1iHyIWOBAm9AKtWLhw4QNdunR5AtfdIHSGI/1hHHW8Q4CQ2Y3jPgibHKSnoMzdEAsP4Zp1RCRw4BK7A+01R/30rIxAfc1wnoclo9vgHis4dOjQWKT1xLEN8Yl33HHHn3FdGFC+BfryGBJ6og4UPf4Byj5w6623fu0y5eTknIIlmXcR/60TN6+88koaflq+M+pce/vtt2+EwKuTlpZ2Ndp7FyJnLfI968pD/FSD+Pk94tfj4ALlIrTz97vuumsK8zhxhMs3UO4Rps2ZM6dqXl7eVOT7HPnuZdrf/va3a9DHbKSdi+hSHO+0b99+TO/evY/yPgPyTEeeJ5DnKkSvwMEltNcx7v+GB+oypLOutjgvR/pv0N7HiNswduzYszCOV6pWrXo5xvs4En+GfLtYvk6dOvcPHjz4YChrkafSxllkISSiz01w+hOO3jiqo71cCOE/33bbbZ8gboM3D+7XZf+RZxTYc15sCPV/CubkOowjB/m4jLgC8T+irrcw139A/Jc46uGYjTENw5h24lpBBERABEQgBgSOHDliFi9ebI/TTjutXJavIl2ichjSKQ4gWJYgdO7atevYGjVqtKFBdBl4zTTcG8M8zBsSFFH5zQvU1Qht3QKDdzcM2V04rkSbaTDQc7BsNAfxTxHvjeNR5H0QRm6Y6xsMci2Um497DXAMQ94bcK86yr6Pe01dPkwQDeM/IAZeZhqM7d0QN1/i8h4Y0nmo81HkmYr6j8HoDkGd/8l8LsDTNQbX2TjGQTycj/M8HJMghLiPxQwZMmQrTo+h3B9QF+8biJv/xalN3bp1RzOO9IvQx8nIMw11/AzXLyH5YeT7He97QmvkeQ73UzCe/jjdj/gNKD8L53GI/4V9wJkCaTbFmyuL+9VxtMf4p+G8Hvkuwr07cf3L3bt3T3L5ijuXNs6iyk2aNKkG+jIPRzsc9+O4FPn2gSu9YVwGNN48GNN9yHMJkr8C77eRh/ltCPU/C2VnIeFFHBS2MxGfwvHjuiPm5ybk4zyfjk8Yb+CsIAIiIAIiUA4Eymv5qmo0xwKD0QFGZD6WnZ6Ecfw9lq2ugTfncrYBr83bEDZ1cS8HeYYib7TElXcIDWD4suhJYSIECI3+MhhCemzoKWL4HMawN9qnV2M8E+BVGYx4/fT09AHZ2dnbmQZDOB9p63GPn/THwFNTEzvDr0X91pDi/iDcz4aXp9Pw4cN3sAzqpfA4A/Hv4SXZgXbb0sPDN4wolGD4KXh+DYH0HPMjLEWZFjjfjcMaWYon9LsPjPYLaOMOnEfAGP/M42FYhrzXwpvDZTKG5aiDYugCHA/jKAxo/0vUNySUsAz1cr/Tfaivn/N4QDSMgIH/D8zJxcj3TGHhHy4+RDt3htKWonw9lH8OHpIH4QlZ6ctro+GO018WwunXSGsNEdwcQi+f98FuCATkSKQdYdzlwRy0cHOM5AUYf0P06/9w7ZgwOze2PYp5n2gjmHf0fyCus+Cxaem8UChbC5xeA4d6HsahIjqJgAiIgAjEikCsl6+iKnAIAYaGwmU4BM4vIGbuhrCx3g5cX4+0v+J+Rqxgod6vPIbPwDjnwYAdgQGb420T8cXohzP8vNUWx5b9+/ePgqgozIo8FDudmbBly5ZTcaqG5adFjEN4DEY9LzpxwzTEuZTUGefjiB5C2ys2bdrUAdeL4EU6G+lc++qBNri0ZAPiGSzj4jzj9bo7Ydi7o43XEMWQbl/i7sNgb8H19PHjxzeGt+galG2Hoxuq3uzyeM7+cS9B3oImTZp86PLQ0MPwf462Wrk0z5ntFwaMfRrGcRR5yatIgVOWcRZW/MNFFvq2yIkbJkEYcvP5n364bf+1ebxzzFSUm4rx50AQVQmVsZmRnmsvQv8gD8d/khM3TMaYlmA5sQrEE4WmlqlCrHQSAREQgaAEsGXCbNu2zR7hbC6O1fJV1AWOAwJDQiHzEoTNYKYh3tfdi9UZbWzz14204zBsu/3pvjg50HD7t3lPhbfjU+aFh6Mx6lkDA7yfhhTenK6I3+Wrpw7ia10amq7K9hnnNc8osw/tWI8E4wifw9NAr0xhgCjifqRDTMA9CsbCQGEDEfEkjj5IfA/1LkCdJ+NcuMRUmBn7jTzX9hJ5j0AEHPCmIw3FbTe9yQZj3+9NgIfr8I4dO44ifzVvuvca9YQ9Tm85XFdDvT9qz3ef0SLzANF+MK2CvpEVRZEN8PwUNf7SngVXXGcREAEREIEABAYOpLP8h4APkFbobN++/YQz/mbTtrqs9szlKx7YlmG6d+9usK3F1K5d+0d5wo3ETOC4DsDgxVzYuLaCntHHL2Bcr4dBfAQCZperB8st1RC3YgTGfjM8UK0nTpx4EgTCHnhnaChPx1EoTlDPENRjBRFFELwwberXr/8F60P5FVCpuJ2yGJ4l69ViurcNxhlQD91IBTDcXMp7HB6fufDc2HohbB5BWjssjbXABui9zI++TEa9JyoU3owg4MH7BYovdFXgYeyLtmsgfYVL85/LMk5vWdRLTr8eN25cfa9XDGO/GRw+4pKYyzNhwoQGbimRdSD9KpxWublimoIIiIAIiEDFE6hevbr90r+ivvgPf7vNzp07zYYNG8zKlSvNqlWrrAhir73LV/369TO9evUq82BiLnDK3KMKKAClOAkw78V+m4nYX/JniIfPICR6Yc/MZCzf/ByCZDG+r2cNljEO7N27twe6OBMT8xbOI5F/Lc7bYPQpRjIgNLjUYSBufo7TO4MGDbJeIYiR9RAiLyDtIZwLIKbegWBqhTbHI/4R9srcx3K4vgmn62DUO2IpZg3iF6Del7EJuFNI0HyP+3shlmqjb7XR3pW4fwPOn+OMU/SEDuuFwMjHAzoJKrw5vCQPoP730dc89hVi5huMwcCbdSE4rGzcuPE3EH/hjvOPqKJLVlZWX7795eYA43oebY7GxubPUff16MNotMm3oKjo7TzB5fkY2huJedqNOeJeqp+DV+GmceZVEAEREAERiA8C+DtuhYzfi8NlLKZhe8gJHcXffZOZmWl69uxpWrdufcL9cBIkcECJm0uxKfgiiJSncczHQa/AtzCaD8NzspgguW8DYuMfSKfvbSaM7R0QPE8iL9/K+Q6T8QIM7jkQRjMgPNYgbRnidnkO1zbAaA+F0f4LIpMhbNJw3o36ZtasWfP/mQGGvT1EBDc+30hxwzQIoaEw4kth+Plq/U1o56848xuU1+HM+ZsLoXE1yr2K/tH7xGWyqASMn2+CPYq+PoYKuWw2De1nu8rxjc0b0ObLyPMmOOyAuGnIe6WNM1S+C86dVq9eXRPnPd45QPwDjJftkf1A96q+Nw/a2wKW9G3uxnEP5mkyzgoiIAIiIAIVTGDu3Llm69atVrxQxBS1FFVcF+FMsMtSeEnJYAWkuGxhpaeElauYTPPnz+fyTbRE0lGstxW7t6OYLkQ9efLkybXhIahd1M8tcGkEHpzZMPL0Yvy2uMb53TXe76Tx5+PyFfbZNIWI2YC6Ai0twaOTDiOfCsNOA28Yh6clzbt042833Di/qRl150F4NcOyTz6EV6OMjIy9/r07rj54U06G92YP7h92aTyXNE4yori55ZZb9njL8JpzAKFYvaSxMA+EXx32z19ecREQAREQgeAE4JUPZJdci/feey9fxHHRsM74TUP73TgdO3Y0cA6EVaa0TJEKHBqn9NIaCfP+Xgick8LMW2HZaMzhOXgfHciD54Tei3kUGTinQAhkIv1/4PngF8/x+3ESMvgFTkIOQp0WAREQAREIRKC8BA4+4Ee8DFXSAPnWSeCAzk0JXNhXMJp1+aqOahSbXbfhbaIL0d/1UKg5OLZhmWY1jq1oiMsk04v7jpiodkSViYAIiIAIiEACEuAyFFY5DD092KcaeI9NaUOPaHkJey1uw1IGf26A+ykCB4gF/jZVwuyhCC2dcFPwfViGScMaY72hQ4duwTisWw/LV4FZxENBCLj12HR9I9Y/9b0w8TAh6oMIiIAIJAGBWCxDlYQloiWqkirWPREQAREQAREQgcQjEM0lKnzwj+kyVEl0I/LglFSx7omACIiACIiACFROAtF8GyooQXlwgpJTOREQAREQARFIQgKRenD4q+EdOnSI2ttQQRFL4AQlp3IiIAIiIAIikIQEIhU48YIkoreo4mUQ6ocIiIAIiIAIiIAIeAlI4Hhp6FoEREAEREAERCApCEjgJMU0ahAiIAIiIAIiIAJeAhI4Xhq6FgEREAEREAERSAoCEjhJMY0ahAiIgAiIgAiIgJeABI6Xhq5FQAREQAREQASSgoAETlJMowYhAiIgAiIgAiLgJSCB46WhaxEQAREQARGo5ATw8wp7Ex0BxyCBk+izqP6LgAiIgAiIQHQJrItudRVS27qq+CXwtC1btjwEtTMI100rpBtqVAREQAREQAREoMwEYLvzYbsnN2rU6AFcHy5zBUUUQH2zkNymiFsJk8QxpGzevHk0evy7hOm1OioCIiACIiACIuAn8MfGjRvf608MEs/Pz89EuTyIhIRc5YHQK0D/s1LpuQkCQGVEQAREQAREQATig0A0bXnTpk2XY1Tj42NkgXoxnmNISHUWaLgqJAIiIAIiIAIiEBaBjIyMERBNuWFljqNM7DP7zi6lcu0ujvqmroiACIiACIiACJSRQLRtOYTCYQiF/jjn4OCST1wH9pF9DfXZ7kVKARRtMo7raVPnREAEREAERKBoAjDqUd9k7G+Je3KgFbLRVl/ca4nrdH+eioijP3ydfR36MwvXE0JLa4Vd+TdCer0MYwvHcQAAAABJRU5ErkJggg=="

/***/ }),

/***/ "LaSh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"v-admin-panel-image-drive"}},[_c('br'),_vm._v(" "),_c('gallery',{attrs:{"collective":_vm.collective}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M++E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25769d4b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminServices_vue__ = __webpack_require__("ft8f");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25769d4b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminServices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23e99df3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("+7iM");
function injectStyle (ssrContext) {
  __webpack_require__("0POj")
  __webpack_require__("ZMRY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23e99df3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MFcx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_376677b5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollectiveMembers_vue__ = __webpack_require__("9zlg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_376677b5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollectiveMembers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ml9D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"v-admin-panel-policies"}},[_c('div',{staticClass:"v-tip-friendly"},[_c('img',{staticClass:"tip-icon",attrs:{"src":__webpack_require__("uk3/")}}),_vm._v(" "),_c('div',{staticClass:"tip-content"},[_c('b',[_vm._v("It's coming.")]),_vm._v(" "),_c('span',[_vm._v("\n        Unfortunately, we haven't gotten around to "),_c('b',[_vm._v("changing policies")]),_vm._v(" on the admin dashboard yet.\n        We hope to finish this before our official release. This is "),_c('b',[_vm._v("priority #6")]),_vm._v(" out of 6 on our list.\n      ")])])]),_vm._v(" "),_c('h4',[_vm._v("What to expect:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Choose a default image download policy for viewers and your followers")]),_vm._v(" "),_c('li',[_vm._v("Select your collective's image crediting preference")]),_vm._v(" "),_c('li',[_vm._v("Add incentives for your followers")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Mo0v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3ec217e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminSettingsPolicies_vue__ = __webpack_require__("Ml9D");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3ec217e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminSettingsPolicies_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_router__ = __webpack_require__("JU1R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resource__ = __webpack_require__("ORbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_app__ = __webpack_require__("It2I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase_auth__ = __webpack_require__("YtIj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_firebase_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase_firestore__ = __webpack_require__("3VHS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_firebase_firestore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase_storage__ = __webpack_require__("qpil");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_firebase_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_infinite_scroll__ = __webpack_require__("bqTm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__("olkN");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

















var config = __webpack_require__("YWcn");

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$firebase = __WEBPACK_IMPORTED_MODULE_5_firebase_app___default.a.initializeApp(config);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$firestore = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$firebase.firestore();
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_infinite_scroll___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_2__router_router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "NpDO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['collective'],
  data: function data() {
    return {
      collectivePictures: this.collective.images,
      pictures: [],
      loading: true,
      pageIndex: 1,
      itemsPerPage: 10,
      columns: 3
    };
  },
  methods: {
    calculateImageClass: function calculateImageClass(index) {
      var classObj = {};
      classObj['grid-item-_' + (Math.floor(index / this.itemsPerPage) + 1)] = true;
      return classObj;
    },
    fetchImageWrapper: function fetchImageWrapper() {
      var _this = this;

      if (this.loading) return false;
      this.fetchNewImages(this.pageIndex + 1).then(function () {
        _this.pageIndex++;
      });
    },
    pluckedImagesFromColumn: function pluckedImagesFromColumn(columnIndex) {
      var _this2 = this;

      if (!this.collective.images || this.collective.images.length === 0) return [];
      return this.pictures.filter(function (val, imgIndex) {
        return imgIndex % _this2.columns === columnIndex % _this2.columns;
      });
    },
    fetchNewImages: function fetchNewImages(currentPage) {
      var _this3 = this;

      if (!this.collective.images || this.collective.images.length === 0) {
        this.loading = false;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(false);
      }

      this.loading = true;
      var images = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.collective.images);

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(images.slice((currentPage - 1) * this.itemsPerPage, this.itemsPerPage + (currentPage - 1) * this.itemsPerPage).map(function (picture) {
        // Find download URLs for each.
        return _this3.$firestore.collection('images').doc('@' + _this3.collective.handle).collection(picture.split('@')[0]).doc(picture.split('@')[1]).get().then(function (pictureDoc) {
          if (!pictureDoc.exists) return false;
          return _this3.$firebase.storage().refFromURL('gs://encadyma-prism-dev.appspot.com/' + pictureDoc.data().fullpath).getDownloadURL().then(function (url) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ picId: picture, url: url }, pictureDoc.data());
          });
        }).catch(function (err) {
          return err;
        });
      })).then(function (newImages) {
        _this3.loading = false;
        _this3.pictures = _this3.pictures.concat(newImages.filter(function (image) {
          return !!image;
        }).sort(function (a, b) {
          return b.timestamp - a.timestamp;
        }));
      });
    }
  },
  mounted: function mounted() {
    if (!this.collective.images) {
      this.loading = false;
      return false;
    }

    this.fetchNewImages(this.pageIndex);
  }
});

/***/ }),

/***/ "NyFt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/OnboardingFinal.4a7b120.png";

/***/ }),

/***/ "OSbk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      step: 1,
      collectiveType: '',
      definedCollectiveHandle: '',
      collectiveName: '',
      forceUsingHandles: false,
      hasCollectiveError: false,
      hasEmptyCollectiveError: false,
      isCheckingUniqueHandle: false
    };
  },
  methods: {
    previousStep: function previousStep() {
      this.step--;
    },
    nextStep: function nextStep() {
      var _this = this;

      if (!this.validateStep(this.step)) return false;

      this.hasEmptyCollectiveError = false;
      this.hasCollectiveError = false;

      // Check for handle uniqueness
      if (this.step === 2 && this.collectiveHandle) {
        this.isCheckingUniqueHandle = true;
        this.confirmUniqueHandle().then(function (isUnique) {
          if (isUnique) {
            _this.hasCollectiveError = false;
            _this.step++;
          } else {
            _this.hasCollectiveError = true;
          }
          _this.isCheckingUniqueHandle = false;
        });
        return true;
      }

      if (this.step === 2 && !this.collectiveHandle) {
        this.hasEmptyCollectiveError = true;
        return false;
      }

      this.step++;
      if (this.step === 4) this.submitSetup();
    },
    validateStep: function validateStep(stepNumber) {
      // Validates the setup at a specific step number
      if (stepNumber === 1 && !this.collectiveType) return false;
      if (stepNumber === 2 && !this.collectiveHandle) return false;
      if (stepNumber === 2 && !this.collectiveName) return false;
      return true;
    },
    submitSetup: function submitSetup() {
      var _this2 = this;

      // Simulate loading delay
      setTimeout(function () {
        _this2.confirmUniqueHandle().then(function (isUnique) {
          if (isUnique) {
            var usersObject = {};
            usersObject[_this2.$store.getters.user.uid] = 1;
            _this2.$firestore.collection('collectives').doc('@' + _this2.collectiveHandle).set({
              createdAt: new Date(),
              fullname: _this2.collectiveName,
              handle: _this2.collectiveHandle,
              headerImageRef: '',
              images: [],
              licensing: {
                commissions: false,
                distributions: {
                  free: false,
                  requiresCrediting: true
                }
              },
              members: usersObject,
              profileImageRef: '',
              services: null,
              followers: {}
            }).then(function () {
              _this2.step = 5;
            });
          } else {
            _this2.hasCollectiveError = true;
            _this2.step = 2;
          }
        });
      }, 3000);
    },
    confirmUniqueHandle: function confirmUniqueHandle() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this3.$firestore.collection('collectives').doc('@' + _this3.collectiveHandle).get().then(function (doc) {
          if (doc.exists) {
            resolve(false);
          } else {
            resolve(true);
          }
        });
      });
    }
  },
  computed: {
    title: function title() {
      switch (this.step) {
        case 1:
          return 'Welcome to Prism';
        case 2:
          return 'Collective Setup';
        case 3:
          return 'Invite Members';
        case 4:
          return 'Finishing up..';
        case 5:
          return 'Finished!';
        default:
          return 'Welcome to Prism';
      }
    },
    collectiveHandle: function collectiveHandle() {
      if (this.collectiveType === 'personal' && !this.forceUsingHandles) return this.$store.getters.user.handle;
      return this.definedCollectiveHandle;
    },
    backNotVisible: function backNotVisible() {
      return {
        notvisible: this.step === 1
      };
    },
    continueNotVisible: function continueNotVisible() {
      return {
        notvisible: !this.validateStep(this.step) || this.hasEmptyCollectiveError || this.isCheckingUniqueHandle
      };
    },
    titleNotVisible: function titleNotVisible() {
      return {
        notvisible: this.step === 5
      };
    },
    barNotVisible: function barNotVisible() {
      return {
        notvisible: this.step === 4 || this.step === 5
      };
    },
    btnContinue: function btnContinue() {
      if (this.step === 3) return 'Finish';
      return 'Continue';
    },
    btnBack: function btnBack() {
      return 'Back';
    }
  }
});

/***/ }),

/***/ "P/RK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"v-login"}},[(_vm.isLoggedIn)?_c('div',[_c('img',{attrs:{"src":__webpack_require__("7Otq"),"height":"210px"}}),_c('br'),_vm._v(" "),_c('h1',{staticClass:"h-thin"},[_vm._v("Logged In")]),_vm._v("\n    You are logged in as "+_vm._s(_vm.$store.getters.user.email)+". "),_c('a',{on:{"click":function($event){_vm.submitLogout()}}},[_vm._v("Log out")]),_vm._v(" "),_c('div',{staticClass:"ipt-submit",class:{loading: _vm.isLoading},on:{"click":function($event){_vm.submitLogout()}}},[_c('i',{staticClass:"ipt-icon material-icons"},[_vm._v("exit_to_app")])])]):_vm._e(),_vm._v(" "),(!_vm.isCreating && !_vm.isLoggedIn)?_c('div',[_c('img',{attrs:{"src":__webpack_require__("7Otq"),"height":"210px"}}),_c('br'),_vm._v(" "),_c('h1',{staticClass:"h-thin"},[_vm._v("Login")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"ipt-container"},[_c('i',{staticClass:"ipt-icon material-icons"},[_vm._v("email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userEmail),expression:"userEmail"}],attrs:{"type":"text","placeholder":"Email Address"},domProps:{"value":(_vm.userEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.userEmail=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"ipt-container"},[_c('i',{staticClass:"ipt-icon text-icons"},[_vm._v("*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userPassword),expression:"userPassword"}],attrs:{"type":"password","placeholder":"Password"},domProps:{"value":(_vm.userPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.userPassword=$event.target.value}}})]),_vm._v(" "),(_vm.error)?_c('div',{staticStyle:{"margin":"10px 0","font-size":"0.8em","color":"#700000"}},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"ipt-submit",class:{loading: _vm.isLoading},on:{"click":function($event){_vm.submitLogin()}}},[_c('i',{staticClass:"ipt-icon material-icons"},[_vm._v("chevron_right")])])]):_vm._e(),_vm._v(" "),(_vm.isCreating && !_vm.isLoggedIn)?_c('div',[_c('img',{attrs:{"src":__webpack_require__("7Otq"),"height":"210px"}}),_c('br'),_vm._v(" "),_c('h1',{staticClass:"h-thin"},[_vm._v("Create Account")]),_vm._v(" "),_c('div',{staticStyle:{"color":"#5B5B5B"}},[_vm._v("Need to login? "),_c('a',{staticClass:"noafter",on:{"click":function($event){_vm.switchForm()}}},[_vm._v("Click here.")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"ipt-container"},[_c('i',{staticClass:"ipt-icon material-icons"},[_vm._v("person")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userFullName),expression:"userFullName"}],attrs:{"type":"text","placeholder":"Full Name"},domProps:{"value":(_vm.userFullName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.userFullName=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"ipt-container"},[_c('i',{staticClass:"ipt-icon text-icons",staticStyle:{"top":"-4px"}},[_vm._v("@")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userHandle),expression:"userHandle"}],attrs:{"type":"text","placeholder":"Username"},domProps:{"value":(_vm.userHandle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.userHandle=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"ipt-container"},[_c('i',{staticClass:"ipt-icon material-icons"},[_vm._v("email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userEmail),expression:"userEmail"}],attrs:{"type":"text","placeholder":"Email Address"},domProps:{"value":(_vm.userEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.userEmail=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"ipt-container"},[_c('i',{staticClass:"ipt-icon text-icons"},[_vm._v("*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userPassword),expression:"userPassword"}],attrs:{"type":"password","placeholder":"Password"},domProps:{"value":(_vm.userPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.userPassword=$event.target.value}}})]),_vm._v(" "),(_vm.error)?_c('div',{staticStyle:{"margin":"10px 0","font-size":"0.8em","color":"#700000"}},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"ipt-submit",class:{loading: _vm.isLoading},on:{"click":function($event){_vm.submitCreation()}}},[_c('i',{staticClass:"ipt-icon material-icons"},[_vm._v("chevron_right")])])]):_vm._e(),_vm._v(" "),_c('br'),_c('br')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PNCf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"v-admin-panel-members"}},[_c('ul',[_vm._v(_vm._s(_vm.collective.members))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QA28":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_262d0a1c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminSupport_vue__ = __webpack_require__("cPBe");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_262d0a1c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminSupport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QrUB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"v-logout-page"}},[(_vm.loading)?_c('div',{staticClass:"c-loading",staticStyle:{"margin-top":"200px","margin-bottom":"40px"}}):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('div',[_c('img',{staticStyle:{"padding-top":"6vh","min-width":"300px"},attrs:{"src":__webpack_require__("7Otq"),"width":"30%"}}),_vm._v(" "),_c('h1',{staticStyle:{"font-weight":"300","font-size":"4em"}},[_vm._v("Logged Out")]),_vm._v(" "),_c('p',{staticStyle:{"color":"#444"}},[_vm._v("You've been logged out. "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Come back to the home page.")])],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RGLW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"v-launch-page"}},[_c('img',{staticStyle:{"padding-top":"6vh","min-width":"300px"},attrs:{"src":__webpack_require__("7Otq"),"width":"30%"}}),_vm._v(" "),_c('h1',{staticStyle:{"font-weight":"300","font-size":"4em"}},[_vm._v("Page Not Found.")]),_vm._v(" "),_c('p',{staticStyle:{"color":"#444"}},[_vm._v("We could not find what you were looking for. "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Come back to the home page.")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RY5o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_663692eb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmptyFrame_vue__ = __webpack_require__("Ce38");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_663692eb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmptyFrame_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RcKU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['collective'],
  methods: {
    goTo: function goTo(route) {
      this.$router.push(route);
    }
  }
});

/***/ }),

/***/ "TRT9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LogoutPage_vue__ = __webpack_require__("9dYn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b3c5e38_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LogoutPage_vue__ = __webpack_require__("QrUB");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LogoutPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b3c5e38_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LogoutPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TUra":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminImageDrive_vue__ = __webpack_require__("KBza");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d6107c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminImageDrive_vue__ = __webpack_require__("LaSh");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminImageDrive_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d6107c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminImageDrive_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "U3gX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Matcher__ = __webpack_require__("k/q4");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['slug'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['allCollectives']), {
    collective: function collective() {
      if (!this.allCollectives['@' + this.slug]) {
        this.$store.dispatch('fetchCollective', this.slug);
        return {};
      }
      return this.allCollectives['@' + this.slug];
    },
    currentRouteName: function currentRouteName() {
      return Object(__WEBPACK_IMPORTED_MODULE_2__Matcher__["a" /* default */])(this.$route.name).name;
    }
  })
});

/***/ }),

/***/ "UVKX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VGFo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XGmb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9fad781c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollectiveServices_vue__ = __webpack_require__("YONW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9fad781c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollectiveServices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YONW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"v-collective-services"}},[_c('img',{attrs:{"src":__webpack_require__("cVn5")}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YWcn":
/***/ (function(module, exports) {

module.exports = {
  apiKey: "AIzaSyBzYy8Nb0wN4wmB_wNlTOLrbSQUTwHqMZM",
  authDomain: "encadyma-prism-dev.firebaseapp.com",
  databaseURL: "https://encadyma-prism-dev.firebaseio.com",
  projectId: "encadyma-prism-dev",
  storageBucket: "encadyma-prism-dev.appspot.com",
  messagingSenderId: "294058600281"
}


/***/ }),

/***/ "YlMb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminDashboard_vue__ = __webpack_require__("RcKU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aff9b712_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminDashboard_vue__ = __webpack_require__("nOQA");
function injectStyle (ssrContext) {
  __webpack_require__("0Qla")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminDashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aff9b712_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminDashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YlY5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginPage_vue__ = __webpack_require__("wBCo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43f8f386_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginPage_vue__ = __webpack_require__("P/RK");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43f8f386_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YmtE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CollectiveFrame',
  props: ['slug'],
  data: function data() {
    return {
      loading: true,
      message: ''
    };
  },
  computed: {
    followers: function followers() {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.state.collectives).indexOf('@' + this.slug) !== -1) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.state.collectives['@' + this.slug].followers).length;
      } else {
        return 0;
      }
    },
    collectiveTitle: function collectiveTitle() {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.state.collectives).indexOf('@' + this.slug) !== -1) {
        return this.$store.state.collectives['@' + this.slug].fullname;
      } else {
        return '@' + this.slug;
      }
    },
    currentCollective: function currentCollective() {
      return this.$store.state.collectives['@' + this.slug] ? this.$store.state.collectives['@' + this.slug] : null;
    }
  },
  created: function created() {
    var _this = this;

    this.$store.dispatch('fetchCollective', this.slug).then(function (data) {
      if (data === false) {
        _this.loading = false;
        _this.message = 'We could not find the collective you were searching for. It most likely was not created yet or was deleted by its creator.';
      } else {
        _this.loading = false;
      }
    }).catch(function () {
      _this.loading = false;
      _this.message = 'We could not get the current collective. Try checking your internet connection.';
    });
  }
});

/***/ }),

/***/ "ZMRY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b9Ce":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"v-collective-gallery"}},[_c('img',{staticStyle:{"margin-top":"20px","margin-bottom":"60px"},attrs:{"src":__webpack_require__("5AUI")}}),_c('br'),_vm._v(" "),_c('gallery',{attrs:{"collective":_vm.collective}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bhxw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['collective']
});

/***/ }),

/***/ "cPBe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"v-admin-panel-followers"}},[_c('div',{staticClass:"v-tip-friendly"},[_c('img',{staticClass:"tip-icon",attrs:{"src":__webpack_require__("uk3/")}}),_vm._v(" "),_c('div',{staticClass:"tip-content"},[_c('b',[_vm._v("It's coming.")]),_vm._v(" "),_c('span',[_vm._v("\n        Unfortunately, we haven't gotten around to "),_c('b',[_vm._v("implementing a support client")]),_vm._v(" into the admin dashboard yet.\n        We hope to finish this before our official release. This is "),_c('b',[_vm._v("priority #3")]),_vm._v(" out of 6 on our list.\n      ")])])]),_vm._v(" "),_c('h4',[_vm._v("What to expect:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Create embeddable HTML/Markdown snippets to promote your Prism website")]),_vm._v(" "),_c('li',[_vm._v("Create a sharable overview of your collective's content")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cVn5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/MockServices.5993b0a.png";

/***/ }),

/***/ "dd06":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"slide-fade"}},[(_vm.pictures.length)?_c('div',[_c('div',{staticClass:"v-collective-grid"},_vm._l((_vm.columns),function(column){return _c('div',{key:column,staticClass:"v-collective-grid-column"},_vm._l((_vm.pluckedImagesFromColumn(column)),function(picture,index){return _c('div',{key:picture.picId,staticClass:"grid-item grid-item-_",class:_vm.calculateImageClass(index)},[_c('img',{attrs:{"src":picture.url}}),_vm._v(" "),_c('div',{staticClass:"v-collective-grid-footer"},[_c('b',[_vm._v(_vm._s(picture.name))])])])}))}))]):_vm._e(),_vm._v(" "),(!_vm.pictures.length && !_vm.loading)?_c('p',{staticStyle:{"font-size":"14px","opacity":"0.6"}},[_vm._v("Looks like this user hasn't uploaded any pictures yet.")]):_vm._e()]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"v-loading-dots"},[_c('i',{staticClass:"v-loading-dot"}),_vm._v(" "),_c('i',{staticClass:"v-loading-dot"}),_vm._v(" "),_c('i',{staticClass:"v-loading-dot"})]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.fetchImageWrapper),expression:"fetchImageWrapper"}],attrs:{"infinite-scroll-disabled":"loading || !pictures.length","infinite-scroll-distance":"50"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ezJm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardFrame_vue__ = __webpack_require__("5hWu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_424989c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardFrame_vue__ = __webpack_require__("69AX");
function injectStyle (ssrContext) {
  __webpack_require__("qgIb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardFrame_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_424989c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardFrame_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ft8f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"v-admin-panel-services"}},[_c('div',{staticClass:"v-tip-friendly"},[_c('img',{staticClass:"tip-icon",attrs:{"src":__webpack_require__("uk3/")}}),_vm._v(" "),_c('div',{staticClass:"tip-content"},[_c('b',[_vm._v("No peeking!")]),_vm._v(" "),_c('span',[_vm._v("\n        Unfortunately, we haven't gotten around to "),_c('b',[_vm._v("implementing services")]),_vm._v(" on the admin dashboard yet.\n        We hope to finish this before our official release. This is "),_c('b',[_vm._v("priority #1")]),_vm._v(" out of 6 on our list.\n      ")])])]),_vm._v(" "),_c('h4',[_vm._v("What to expect:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("View your collective's followers")]),_vm._v(" "),_c('li',[_vm._v("Create a sharable overview of your collective's content")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gR74":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"v-admin-panel-general"}},[_c('div',{staticClass:"v-tip-friendly"},[_c('img',{staticClass:"tip-icon",attrs:{"src":__webpack_require__("uk3/")}}),_vm._v(" "),_c('div',{staticClass:"tip-content"},[_c('b',[_vm._v("It's coming.")]),_vm._v(" "),_c('span',[_vm._v("\n        Unfortunately, we haven't gotten around to "),_c('b',[_vm._v("general settings")]),_vm._v(" on the admin dashboard yet.\n        We hope to finish this before our official release. This is "),_c('b',[_vm._v("priority #2")]),_vm._v(" out of 6 on our list.\n      ")])])]),_vm._v(" "),_c('h4',[_vm._v("What to expect:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Change collective's full name")]),_vm._v(" "),_c('li',[_vm._v("Upload collective profile icon")]),_vm._v(" "),_c('li',[_vm._v("Upload collective profile banner")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "k/q4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (routeName) {
  switch (routeName) {
    case 'AdminUpload':
      return { name: 'Upload Images', code: 1 };
    case 'AdminDashboard':
      return { name: 'Dashboard', code: 2 };
    case 'AdminImageDrive':
      return { name: 'Images', code: 3 };
    case 'AdminServices':
      return { name: 'Services', code: 4 };
    case 'AdminFollowers':
      return { name: 'Followers', code: 5 };
    case 'AdminSupport':
      return { name: 'Support', code: 9 };
    case 'AdminSettingsGeneral':
      return { name: 'General Settings', code: 6 };
    case 'AdminSettingsMembers':
      return { name: 'Members', code: 7 };
    case 'AdminSettingsPolicies':
      return { name: 'Policies', code: 8 };
    default:
      return { name: 'Not Found!', code: -1 };
  }
});

/***/ }),

/***/ "lM8h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf1692ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageNotFound_vue__ = __webpack_require__("RGLW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf1692ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageNotFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "m5dy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ShadedLogo.8e47b23.png";

/***/ }),

/***/ "nOQA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"v-admin-panel-dashboard"}},[_c('div',{staticClass:"v-admin-panel-dash"},[_c('div',{staticClass:"v-admin-panel-dash-element"},[_c('div',{staticClass:"v-admin-panel-dash-title"},[_c('h1',[_vm._v(_vm._s(_vm.collective.images ? Object.keys(_vm.collective.images).length : 0))]),_vm._v(" "),_c('span',[_vm._v("images")])]),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.goTo('./images')}}},[_vm._v("VIEW IMAGES "),_c('i',{staticClass:"material-icons"},[_vm._v("chevron_right")])])]),_vm._v(" "),_c('div',{staticClass:"v-admin-panel-dash-element"},[_c('div',{staticClass:"v-admin-panel-dash-title"},[_c('h1',[_vm._v(_vm._s(_vm.collective.members ? Object.keys(_vm.collective.members).length : 0))]),_vm._v(" "),_c('span',[_vm._v("members")])]),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.goTo('./members')}}},[_vm._v("VIEW MEMBERS "),_c('i',{staticClass:"material-icons"},[_vm._v("chevron_right")])])])]),_vm._v(" "),_c('div',{staticClass:"v-admin-panel-copypaste"},[_vm._v("\n    Your public presence is located at "),_c('input',{staticClass:"copypaste",attrs:{"readonly":"readonly"},domProps:{"value":'prism.encadyma.com/@/' + _vm.collective.handle}})]),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-tip-friendly"},[_c('img',{staticClass:"tip-icon",attrs:{"src":__webpack_require__("uk3/")}}),_vm._v(" "),_c('div',{staticClass:"tip-content"},[_c('b',[_vm._v("Hello!")]),_vm._v(" "),_c('span',[_vm._v("\n        This is your Prism dashboard. Above me are some common options for starting out.\n        If you can't find what you need above, the sidebar to the left can also help you out.\n      ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "of2w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_Gallery__ = __webpack_require__("GSIy");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['collective'],
  components: { Gallery: __WEBPACK_IMPORTED_MODULE_3__Components_Gallery__["a" /* default */] },
  data: function data() {
    return {
      collectivePictures: this.collective.images,
      pictures: [],
      loading: true,
      pageIndex: 1,
      itemsPerPage: 10,
      columns: 3
    };
  },
  methods: {
    calculateImageClass: function calculateImageClass(index) {
      var classObj = {};
      classObj['grid-item-_' + (Math.floor(index / this.itemsPerPage) + 1)] = true;
      return classObj;
    },
    fetchImageWrapper: function fetchImageWrapper() {
      var _this = this;

      if (this.loading) return false;
      this.fetchNewImages(this.pageIndex + 1).then(function () {
        _this.pageIndex++;
      });
    },
    pluckedImagesFromColumn: function pluckedImagesFromColumn(columnIndex) {
      var _this2 = this;

      return this.pictures.filter(function (val, imgIndex) {
        return imgIndex % _this2.columns === columnIndex % _this2.columns;
      });
    },
    fetchNewImages: function fetchNewImages(currentPage) {
      var _this3 = this;

      this.loading = true;
      var images = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.collective.images);

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(images.slice((currentPage - 1) * this.itemsPerPage, this.itemsPerPage + (currentPage - 1) * this.itemsPerPage).map(function (picture) {
        // Find download URLs for each.
        return _this3.$firestore.collection('images').doc('@' + _this3.collective.handle).collection(picture.split('@')[0]).doc(picture.split('@')[1]).get().then(function (pictureDoc) {
          if (!pictureDoc.exists) return false;
          return _this3.$firebase.storage().refFromURL('gs://encadyma-prism-dev.appspot.com/' + pictureDoc.data().fullpath).getDownloadURL().then(function (url) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ picId: picture, url: url }, pictureDoc.data());
          });
        }).catch(function (err) {
          return err;
        });
      })).then(function (newImages) {
        _this3.loading = false;
        _this3.pictures = _this3.pictures.concat(newImages.filter(function (image) {
          return !!image;
        }).sort(function (a, b) {
          return b.timestamp - a.timestamp;
        }));
      });
    }
  },
  mounted: function mounted() {
    if (!this.collective.images) {
      this.loading = false;
      return false;
    }

    this.fetchNewImages(this.pageIndex);
  }
});

/***/ }),

/***/ "olkN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");


// Router module




var MD5 = __webpack_require__("gykg");

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
  state: {
    collectives: {},
    users: [],
    images: [],
    userCollectives: {},
    currentUser: null,
    currentUserContext: {
      handle: '',
      fullname: '',
      userProfileImg: '',
      r_user_id: ''
    }
  },
  getters: {
    user: function user(state) {
      return state.currentUser ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state.currentUser, state.currentUserContext) : false;
    },
    allCollectives: function allCollectives(state) {
      return state.collectives;
    }
  },
  mutations: {
    loginUser: function loginUser(state, payload) {
      state.currentUser = payload;
    },
    logoutUser: function logoutUser(state) {
      state.currentUser = null;
    },
    updateUser: function updateUser(state, payload) {
      state.currentUser = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state.currentUser, payload);
    },
    updateContext: function updateContext(state, payload) {
      state.currentUserContext = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state.currentUserContext, payload);
    },
    addCollective: function addCollective(state, payload) {
      // `payload` must be the collective object, no exceptions!
      var collectiveWrapper = {};
      collectiveWrapper['@' + payload.handle] = payload;
      state.collectives = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state.collectives, collectiveWrapper);
    },
    addUserCollective: function addUserCollective(state, payload) {
      // `payload` must be the collective object, no exceptions!
      var collectiveWrapper = {};
      collectiveWrapper['@' + payload.handle] = payload;
      state.collectives = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state.collectives, collectiveWrapper);
      state.collectives = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state.userCollectives, collectiveWrapper);
    }
  },
  actions: {
    fetchUser: function fetchUser(_ref, payload) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      // This applies throughout the entire app. No need to duplicate
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype.$firebase.auth().onAuthStateChanged(function (user) {
        if (user) {
          commit('loginUser', user);
          dispatch('updateUserContext');
        } else {
          commit('logoutUser');
        }
      });
    },
    updateUserContext: function updateUserContext(_ref2) {
      var state = _ref2.state,
          commit = _ref2.commit;

      // Fetches information from the user database
      // or uses local storage information
      commit('updateContext', {
        userProfileImg: 'https://www.gravatar.com/avatar/' + MD5(String.toLowerCase(state.currentUser.email.trim())),
        r_user_id: state.currentUser.uid
      });

      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype.$firestore.collection('users').doc(state.currentUser.uid).get().then(function (doc) {
        if (doc.exists) {
          commit('updateContext', doc.data());
        } else {
          // Create a document for no errors
          // Account Creation:
          // Be sure to set the currentUserContext!
          __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype.$firestore.collection('users').doc(state.currentUser.uid).set(state.currentUserContext, { merge: true });
        }
      }).catch(function () {
        throw new Error('Could not get the current user!');
      });
    },
    fetchCollective: function fetchCollective(_ref3, payload) {
      var state = _ref3.state,
          commit = _ref3.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype.$firestore.collection('collectives').doc('@' + payload).get().then(function (doc) {
          if (doc.exists) {
            commit('addCollective', doc.data());
            resolve(doc.data());
          } else {
            resolve(false);
          }
        }).catch(function () {
          throw new Error('Could not get the current collective!');
        });
      });
    },
    fetchUserCollectives: function fetchUserCollectives(_ref4) {
      var state = _ref4.state,
          commit = _ref4.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (state.currentUser) {
          __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype.$firestore.collection('collectives').where('members.' + state.currentUser.uid, '>=', 1).get().then(function (docs) {
            docs.forEach(function (collective) {
              commit('addUserCollective', collective.data());
            });
            resolve(true);
          });
        } else {
          resolve(false);
        }
      });
    }
  }
}));

/***/ }),

/***/ "pru8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/MockOnboardingCollectiveSample.be4c17b.png";

/***/ }),

/***/ "qTfU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"v-forbidden-page"}},[_c('img',{staticStyle:{"padding-top":"6vh","min-width":"300px"},attrs:{"src":__webpack_require__("7Otq"),"width":"30%"}}),_vm._v(" "),_c('h1',{staticStyle:{"font-weight":"300","font-size":"4em"}},[_vm._v("Forbidden.")]),_vm._v(" "),_c('p',{staticStyle:{"color":"#444"}},[_vm._v("You do not have the permissions to access this resource. "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Come back to the home page.")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qd0v":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/MockOnboardingInviteMembers.f1ac64d.png";

/***/ }),

/***/ "qgIb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rTZy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CollectiveGallery_vue__ = __webpack_require__("of2w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63c0616e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollectiveGallery_vue__ = __webpack_require__("b9Ce");
function injectStyle (ssrContext) {
  __webpack_require__("9HFc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CollectiveGallery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63c0616e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollectiveGallery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "s5+B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tHcj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CollectiveFrame_vue__ = __webpack_require__("YmtE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f9741ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollectiveFrame_vue__ = __webpack_require__("xNZP");
function injectStyle (ssrContext) {
  __webpack_require__("s5+B")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f9741ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CollectiveFrame_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f9741ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollectiveFrame_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tN4C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"v-admin-frame"}},[_c('div',{staticClass:"admin-sidebar"},[_c('router-link',{staticClass:"admin-sidebar-profile",staticStyle:{"margin-top":"0"},attrs:{"to":"/dashboard","title":"Change Collectives"}}),_vm._v(" "),_c('router-link',{staticClass:"admin-sidebar-item",attrs:{"to":"./upload","title":"Upload"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_upload")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('router-link',{staticClass:"admin-sidebar-item",attrs:{"to":"./dashboard","title":"Dashboard"}},[_c('i',{staticClass:"material-icons"},[_vm._v("dashboard")])]),_vm._v(" "),_c('router-link',{staticClass:"admin-sidebar-item",attrs:{"to":"./images","title":"Images"}},[_c('i',{staticClass:"material-icons"},[_vm._v("image")])]),_vm._v(" "),_c('router-link',{staticClass:"admin-sidebar-item",attrs:{"to":"./widgets","title":"Support"}},[_c('i',{staticClass:"material-icons"},[_vm._v("device_hub")])])],1),_vm._v(" "),_c('div',{staticClass:"v-admin-default-container",staticStyle:{"text-align":"left"}},[_c('div',{staticClass:"admin-header-headings"},[_c('h5',[_vm._v(_vm._s(_vm.collective.fullname))]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.currentRouteName))])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('router-view',{attrs:{"collective":_vm.collective}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uk3/":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "v5p1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vaHH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-prism-launch"},[_c('router-link',{staticClass:"aqua-realmer",attrs:{"to":"login"}},[_vm._v("Login")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('footer',[_vm._v("Developed by the Prism Group. All Rights Reserved.")])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"panel panel-intro"},[_c('div',{staticClass:"panel-intro-description"},[_c('h1',[_vm._v("Prism"),_c('small',{staticStyle:{"font-size":"36px"}},[_vm._v(" (α)")])]),_vm._v(" "),_c('p',[_vm._v("Share your photography. Build your platform. Color your story. "),_c('br'),_c('b',{staticStyle:{"font-weight":"600"}},[_vm._v("Coming to private alpha in 12.4.2017.")])]),_vm._v(" "),_c('div',{attrs:{"id":"mc_embed_signup"}},[_c('form',{staticClass:"validate",attrs:{"action":"https://omnilabs.us3.list-manage.com/subscribe/post?u=7cd0a8551378b65ce1c88d5ee&id=3659372f0a","method":"post","id":"mc-embedded-subscribe-form","name":"mc-embedded-subscribe-form","target":"_blank","novalidate":""}},[_c('div',{attrs:{"id":"mc_embed_signup_scroll"}},[_c('small',[_vm._v("SIGN UP FOR UPDATES")]),_vm._v(" "),_c('div',{staticClass:"mc-field-group",staticStyle:{"display":"inline-block"}},[_c('input',{staticClass:"required email",attrs:{"type":"email","value":"","name":"EMAIL","id":"mce-EMAIL","placeholder":"Enter your email address"}})]),_vm._v(" "),_c('div',{staticStyle:{"position":"absolute","left":"-5000px"},attrs:{"aria-hidden":"true"}},[_c('input',{attrs:{"type":"text","name":"b_7cd0a8551378b65ce1c88d5ee_3659372f0a","tabindex":"-1","value":""}})]),_vm._v(" "),_c('div',{staticClass:"clear",staticStyle:{"display":"inline-block","margin-left":"10px"}},[_c('input',{staticClass:"button",attrs:{"type":"submit","value":"Subscribe","name":"subscribe","id":"mc-embedded-subscribe"}})]),_vm._v(" "),_c('div',{staticClass:"clear",attrs:{"id":"mce-responses"}},[_c('div',{staticClass:"response",staticStyle:{"display":"none"},attrs:{"id":"mce-error-response"}}),_vm._v(" "),_c('div',{staticClass:"response",staticStyle:{"display":"none"},attrs:{"id":"mce-success-response"}})])])])])]),_vm._v(" "),_c('img',{staticStyle:{"position":"absolute","right":"calc(50% - 540px)","top":"15vh"},attrs:{"src":__webpack_require__("m5dy"),"height":"45%"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"panel panel-what"},[_c('h1',[_vm._v("What is Prism?")]),_vm._v(" "),_c('div',{staticClass:"panel-what-segments"},[_c('div',{staticClass:"panel-what-segment"},[_c('i',{staticClass:"material-icons"},[_vm._v("cloud_upload")]),_vm._v(" "),_c('h4',[_vm._v("A cloud for all images.")]),_vm._v(" "),_c('div',{staticClass:"segment-divider"}),_vm._v(" "),_c('p',[_vm._v("Prism is a convenient host for your collective's images. We provide our collectives with an opportunity to gracefully upload their image collections for safe backup and easy sharing, no matter how large the collection may be.")])]),_vm._v(" "),_c('div',{staticClass:"panel-what-segment"},[_c('i',{staticClass:"material-icons"},[_vm._v("explore")]),_vm._v(" "),_c('h4',[_vm._v("A web presence to be proud of.")]),_vm._v(" "),_c('div',{staticClass:"segment-divider"}),_vm._v(" "),_c('p',[_vm._v("On top of providing a convenient place for image storage, Prism also hosts a sharable website that puts your images and services in center focus. No need to hire a web designer or do additional work just to update your image collection.")])]),_vm._v(" "),_c('div',{staticClass:"panel-what-segment"},[_c('i',{staticClass:"material-icons"},[_vm._v("store")]),_vm._v(" "),_c('h4',[_vm._v("A store for old goods & new chances.")]),_vm._v(" "),_c('div',{staticClass:"segment-divider"}),_vm._v(" "),_c('p',[_vm._v("Sell your images. Prism allows your team to handle the selling process for your preexisitng works. Or sell for new opportunities. Prism allows you to sell commissioned services and open new opportunities with your consumers. Have the freedom to do what you love without drawbacks.")])]),_vm._v(" "),_c('div',{staticClass:"panel-what-segment"},[_c('i',{staticClass:"material-icons"},[_vm._v("people")]),_vm._v(" "),_c('h4',[_vm._v("A home for photography teams.")]),_vm._v(" "),_c('div',{staticClass:"segment-divider"}),_vm._v(" "),_c('p',[_vm._v("Collectives in Prism are designed to be hyper-collaborative spaces for your members to work in, and we are doing our best to make the inviting process as simple as it can be.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"panel panel-faq"},[_c('h1',[_vm._v("FAQ")]),_vm._v(" "),_c('ul',[_c('li',[_c('h3',[_vm._v("Q. What will the private alpha be like?")]),_vm._v(" "),_c('p',[_vm._v("The private alpha will start off with image upload functionality and a basic sharable web presence for new collectives. Prism's functionality will slowly grow from here as feedback and interest grows until we are comfortable enough to transition to a public beta.")])]),_vm._v(" "),_c('li',[_c('h3',[_vm._v("Q. Who will have access to the private alpha?")]),_vm._v(" "),_c('p',[_vm._v("Our developers are reaching out to local photography groups to be our first testers. If your team is interested in trying out Prism, please keep in contact by entering your email above. We are looking for creative photographers that make great influences in their communities.")])]),_vm._v(" "),_c('li',[_c('h3',[_vm._v("Q. When will Prism have its first public release?")]),_vm._v(" "),_c('p',[_vm._v("Prism is an ambitious product that our developers feel should not be rushed. As such, we cannot give an accurate estimate on a public release, but we hope to make an announcement on this topic on or before Q2 2018.")])]),_vm._v(" "),_c('li',[_c('h3',[_vm._v("Q. How will Prism's services be priced?")]),_vm._v(" "),_c('p',[_vm._v("Upon public launch, Prism will be based on a monthly subscription model.")])]),_vm._v(" "),_c('li',[_c('h3',[_vm._v("Q. How can the Prism developers be contacted?")]),_vm._v(" "),_c('p',[_vm._v("You can contact the developers via email through "),_c('a',{attrs:{"href":"mailto:prism@encadyma.com"}},[_vm._v("prism@encadyma.com")]),_vm._v(".")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vlpO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wBCo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isCreating: false,
      userEmail: '',
      userHandle: '',
      userFullName: '',
      userPassword: '',
      error: '',
      isLoading: false,
      isLoggedIn: false
    };
  },
  created: function created() {
    var _this = this;

    if (this.$store.getters.user) {
      this.isLoggedIn = true;
    }
    this.$firebase.auth().onAuthStateChanged(function (user) {
      _this.isLoading = false;
      if (user) {
        if (_this.isCreating) {
          // Initialize account
          _this.$store.commit('updateContext', {
            handle: _this.userHandle,
            fullname: _this.userFullName
          });
        }

        _this.$router.push({ path: _this.isCreating ? 'onboarding' : 'dashboard' });
        _this.isLoggedIn = true;
      } else {
        // Signed out user.
        _this.isLoggedIn = false;
      }
    });
  },
  methods: {
    switchForm: function switchForm() {
      if (!this.isLoading) {
        this.isCreating = !this.isCreating;
      }
    },
    submitLogin: function submitLogin() {
      var _this2 = this;

      if (this.validateLogin() && !this.isLoading) {
        this.isLoading = true;
        this.$firebase.auth().signInWithEmailAndPassword(this.userEmail, this.userPassword).catch(function (err) {
          _this2.isLoading = false;
          _this2.error = err.message;
        });
      }
    },
    submitLogout: function submitLogout() {
      var _this3 = this;

      this.isLoading = true;
      setTimeout(function () {
        _this3.$firebase.auth().signOut();
      }, 1000);
    },
    submitCreation: function submitCreation() {
      var _this4 = this;

      if (this.validateCreation() && !this.isLoading) {
        this.isLoading = true;
        this.$firebase.auth().createUserWithEmailAndPassword(this.userEmail, this.userPassword).catch(function (err) {
          _this4.isLoading = false;
          _this4.error = err.message;
        });
      }
    },
    validateLogin: function validateLogin() {
      if (!this.userEmail.trim().length) {
        this.error = 'Email is required';
        return false;
      }
      if (!this.userPassword.trim().length) {
        this.error = 'Password is required';
        return false;
      }
      this.error = '';
      return true;
    },
    validateCreation: function validateCreation() {
      if (this.validateLogin()) {
        if (!this.userFullName.trim().length) {
          this.error = 'Full name is required';
          return false;
        }
        if (!this.userHandle.trim().length) {
          this.error = 'A username is required';
          return false;
        }
        if (!/^[a-zA-Z0-9]+$/.test(this.userHandle)) {
          this.error = 'A valid username (alphanumeric) is required';
          return false;
        }
        this.error = '';
        return true;
      } else {
        return false;
      }
    }
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  created: function created() {
    this.$store.dispatch('fetchUser');
  }
});

/***/ }),

/***/ "xLCW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminFollowers_vue__ = __webpack_require__("bhxw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a947578_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminFollowers_vue__ = __webpack_require__("Bqv4");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminFollowers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a947578_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminFollowers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xNZP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"v-collective-frame"}},[(!_vm.loading)?_c('div',{staticClass:"collective-header"},[(!_vm.message)?_c('h1',{staticClass:"collective-header-heading"},[_c('span',[_vm._v(_vm._s(_vm.collectiveTitle))])]):_vm._e(),_vm._v(" "),(_vm.message)?_c('h1',{staticClass:"collective-header-heading"},[_c('span',{staticStyle:{"text-transform":"uppercase","margin-top":"30vh","display":"block"}},[_vm._v("An error occurred.")])]):_vm._e(),_vm._v(" "),(!_vm.message)?_c('nav',{staticClass:"collective-header-nav"},[_c('button',[_vm._v("Follow ("+_vm._s(_vm.followers)+")")]),_vm._v(" "),_c('router-link',{attrs:{"to":"./gallery"}},[_vm._v("Gallery")]),_vm._v(" "),_c('router-link',{attrs:{"to":"./members"}},[_vm._v("Members")]),_vm._v(" "),_c('router-link',{attrs:{"to":"./services"}},[_vm._v("Services")])],1):_vm._e()]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[(!_vm.loading && !_vm.message)?_c('router-view',{attrs:{"collective":_vm.currentCollective}}):_vm._e(),_vm._v(" "),(!_vm.loading && _vm.message)?_c('div',{staticStyle:{"max-width":"500px","margin":"0 auto","line-height":"1.5"}},[_c('p',[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Return to home.")])],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ynP9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"v-onboarding-frame"}},[_c('header',{staticClass:"ob-header"},[_c('div',{staticClass:"ob-header-heading",class:_vm.titleNotVisible},[_c('h5',[_vm._v("Account Setup")]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"ob-header-profile"},[_c('div',{staticClass:"ob-header-profile-head"},[_c('b',{staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(_vm.$store.getters.user.fullname))]),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"0.8em","color":"#929292"}},[_vm._v("@"+_vm._s(_vm.$store.getters.user.handle))])]),_vm._v(" "),_c('img',{staticClass:"ob-header-profile-img",attrs:{"src":_vm.$store.getters.user.userProfileImg}})])]),_vm._v(" "),_c('div',{attrs:{"id":"v-collective-view"}},[_c('transition',{attrs:{"name":"slide-side-fade","mode":"out-in"}},[(_vm.step == 1)?_c('div',{key:"step1",attrs:{"id":"v-collective-members"}},[_c('div',{staticStyle:{"text-align":"left","line-height":"1.4","max-width":"240px","margin-right":"40px"}},[_c('div',{staticClass:"medallion"}),_vm._v(" "),_c('b',[_vm._v("Welcome to Prism!")]),_vm._v(" "),_c('p',[_vm._v("We’re excited to have you join us. Soon, you will be up and running with an online hub to showcase your photography.")]),_vm._v(" "),_c('p',[_vm._v("To begin, you must first start a "),_c('b',[_vm._v("Collective")]),_vm._v(" to store and host your images in.")]),_vm._v(" "),_c('p',[_vm._v("What type of collective will you be creating?")])]),_vm._v(" "),_c('div',{staticClass:"v-collective-option-jumbo",class:{selected: _vm.collectiveType == 'personal'},on:{"click":function($event){_vm.collectiveType = 'personal'}}},[_c('i',{staticClass:"material-icons"},[_vm._v("person")]),_c('br'),_vm._v(" "),_c('b',[_vm._v("I want to create a")]),_vm._v(" "),_c('h2',{staticClass:"h-thin"},[_vm._v("Personal Collective")]),_vm._v(" "),_c('i',{staticStyle:{"font-size":"12px","display":"inline-block","width":"150px","margin":"10px","margin-bottom":"16px"}},[_vm._v("For showcasing your own photography")]),_c('br'),_vm._v(" "),(_vm.collectiveType == 'personal')?_c('div',{staticClass:"text-divvy"},[_vm._v("SELECTED")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"v-collective-option-jumbo v-collective-option-dark",class:{selected: _vm.collectiveType == 'team'},on:{"click":function($event){_vm.collectiveType = 'team'}}},[_c('i',{staticClass:"material-icons"},[_vm._v("group")]),_c('br'),_vm._v(" "),_c('b',[_vm._v("I want to create a")]),_vm._v(" "),_c('h2',{staticClass:"h-thin"},[_vm._v("Team Collective")]),_vm._v(" "),_c('i',{staticStyle:{"font-size":"12px","display":"inline-block","width":"150px","margin":"10px","margin-bottom":"16px"}},[_vm._v("For showcasing your team's photography")]),_c('br'),_vm._v(" "),(_vm.collectiveType == 'team')?_c('div',{staticClass:"text-divvy"},[_vm._v("SELECTED")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.step == 2)?_c('div',{key:"step2",attrs:{"id":"v-collective-cform"}},[_c('div',{staticStyle:{"text-align":"left"}},[_c('b',{staticStyle:{"display":"block"}},[_vm._v("Collective Name (*)")]),_vm._v(" "),_c('div',{staticClass:"ipt-container no-left",staticStyle:{"display":"block","margin-left":"0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.collectiveName),expression:"collectiveName"}],attrs:{"type":"text"},domProps:{"value":(_vm.collectiveName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.collectiveName=$event.target.value}}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b',{staticStyle:{"display":"block"}},[_vm._v("Site Handle (*)")]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"display":"inline-block","margin":"8px 0","font-size":"1.4em","font-weight":"300"}},[_vm._v("prism.encadyma.com/@/"),(!_vm.forceUsingHandles && _vm.collectiveType == 'personal')?_c('b',[_vm._v(_vm._s(_vm.$store.getters.user.handle))]):_vm._e()]),_vm._v(" "),(_vm.collectiveType == 'team' || _vm.forceUsingHandles)?_c('div',{staticClass:"ipt-container no-left",staticStyle:{"display":"inline-block","width":"200px","vertical-align":"top"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.definedCollectiveHandle),expression:"definedCollectiveHandle"}],staticStyle:{"margin":"0"},attrs:{"type":"text"},domProps:{"value":(_vm.definedCollectiveHandle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.definedCollectiveHandle=$event.target.value}}})]):_vm._e()]),_vm._v(" "),(!_vm.forceUsingHandles && _vm.collectiveType == 'personal')?_c('i',{staticStyle:{"font-size":"12px","color":"#444"}},[_vm._v("\n            Personal collectives use your account's handle as the default site handle."),_c('br'),_vm._v("\n            If you prefer to use a different site handle, "),_c('a',{staticStyle:{"vertical-align":"text-top"},on:{"click":function($event){_vm.forceUsingHandles = true}}},[_vm._v("click here.")])]):_vm._e(),_vm._v(" "),(_vm.forceUsingHandles && _vm.collectiveType == 'personal')?_c('i',{staticStyle:{"font-size":"12px","color":"#444"}},[_vm._v("\n            If you prefer to go back and use your account's handle, "),_c('a',{staticStyle:{"vertical-align":"text-top"},on:{"click":function($event){_vm.forceUsingHandles = false}}},[_vm._v("click here.")])]):_vm._e(),_vm._v(" "),(_vm.hasEmptyCollectiveError)?_c('i',{staticStyle:{"font-size":"12px","color":"#ff2222"}},[_vm._v("\n            Please enter in a collective handle.\n          ")]):_vm._e(),_vm._v(" "),(_vm.hasCollectiveError)?_c('i',{staticStyle:{"font-size":"12px","color":"#ff2222"}},[_vm._v("\n            It seems like this name has already been taken. Please use a different handle.\n          ")]):_vm._e()]),_vm._v(" "),_c('img',{staticStyle:{"height":"460px"},attrs:{"src":__webpack_require__("pru8")}})]):_vm._e(),_vm._v(" "),(_vm.step == 3)?_c('div',{key:"step3",attrs:{"id":"v-collective-inviteform"}},[_c('div',[_c('img',{staticStyle:{"margin-bottom":"40px"},attrs:{"src":__webpack_require__("LYWo")}}),_vm._v(" "),_c('img',{staticStyle:{"margin-bottom":"40px"},attrs:{"src":__webpack_require__("qd0v")}})]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"left","margin-left":"100px","margin-right":"20px","max-width":"240px","line-height":"1.4"}},[_c('div',{staticClass:"medallion"}),_vm._v(" "),_c('b',[_vm._v("Setting up your team is easy.")]),_vm._v(" "),_c('p',[_vm._v("Whether a member is a photographer, designer, or manager, Prism has a flexible set of user roles for your team.")]),_vm._v(" "),_c('p',[_vm._v("To add a member, you may either send an "),_c('b',[_vm._v("invitation")]),_vm._v(" to an email address or create a "),_c('b',[_vm._v("shareable invite link")]),_vm._v(" to share among a group.")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"14px","color":"#807D7D"}},[_vm._v("Invitations will be live updated. "),_c('a',[_c('b',{staticStyle:{"font-weight":"600"}},[_vm._v("Click here to manually refresh.")])])])]),_vm._v(" "),_c('div',{staticStyle:{"position":"absolute","top":"60px","left":"calc(50% - 200px)","filter":"none","width":"400px","opacity":"1"}},[_c('h1',[_vm._v("Inviting members is not enabled yet")]),_vm._v(" "),_c('p',[_vm._v("This feature will be enabled in a later release of Prism. For now, you may invite members in the admin panel of your Collective.")]),_vm._v(" "),_c('p',[_vm._v("Click on 'Finish' to complete the setup.")])])]):_vm._e(),_vm._v(" "),(_vm.step == 4)?_c('div',{key:"step4",attrs:{"id":"v-collective-loading"}},[_c('div',{staticClass:"c-loading",staticStyle:{"margin-top":"40px","margin-bottom":"40px"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#555"}},[_vm._v("Finishing up..")])]):_vm._e(),_vm._v(" "),(_vm.step == 5)?_c('div',{key:"step5",attrs:{"id":"v-collective-fform"}},[_c('img',{staticStyle:{"position":"absolute","left":"0","top":"0","height":"100%"},attrs:{"src":__webpack_require__("NyFt")}}),_vm._v(" "),_c('div',{staticStyle:{"position":"absolute","height":"450px","right":"45vh"}},[_c('div',{staticStyle:{"text-align":"left","line-height":"1.4","max-width":"240px"}},[_c('div',{staticClass:"medallion"}),_vm._v(" "),_c('b',[_vm._v("Prism is now setup.")]),_vm._v(" "),_c('p',[_vm._v("Your account is now ready for use and has full access to Prism’s services.")]),_vm._v(" "),_c('p',[_vm._v("Take a deep breath. Get excited. There’s a lot that Prism has to offer and a great deal more to explore, starting from the Dashboard.")]),_vm._v(" "),_c('p',[_vm._v("Thank you for choosing Prism. We can’t wait to see how you color your story.")]),_vm._v(" "),_c('p',{staticStyle:{"font-weight":"300"}},[_vm._v("- Prism Group")])]),_vm._v(" "),_c('router-link',{staticStyle:{"display":"inline-block","margin-top":"40px"},attrs:{"to":"dashboard"}},[_vm._v("Go to Dashboard")])],1)]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"ob-buttons",class:_vm.barNotVisible},[_c('button',{class:_vm.backNotVisible,on:{"click":function($event){_vm.previousStep()}}},[_vm._v(_vm._s(_vm.btnBack))]),_vm._v(" "),_c('button',{class:_vm.continueNotVisible,on:{"click":function($event){_vm.nextStep()}}},[_vm._v(_vm._s(_vm.btnContinue))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.37b8069313f6121c9f1d.js